import { getAnalyticsClient, getGlobal, setGlobal } from './helpers';

function getClient(id) {
  /* Ported over (relatively) unchanged from the Facebook docs example
   * (yes there are probably much prettier ways to write this) */
  if (!getGlobal('_fbq')) {
    const fbq = function fbqPush(...args) {
      return fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    setGlobal('_fbq', fbq);
    setGlobal('fbq', fbq);
  }

  return getAnalyticsClient(
    '_fbq',
    '//connect.facebook.net/en_US/fbevents.js',
    fbq => fbq('init', id)
  );
}

/**
 * The Facebook analytics client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name facebook
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains the required facebook `id` (which is provided to Carvana for our paid enterprise account)
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function facebook(config = {}, log, noPublish) {
  return {
    async trackEvent(eventName, eventData) {
      const trackEventFacebook = await getClient(config.id);

      if (trackEventFacebook) {
        if (log) {
          log('[Analytics_Facebook_Event]', { eventName, eventData });
        }

        if (!noPublish) {
          trackEventFacebook.push(eventName);
        }
      }
    },

    async trackConversion(eventName, eventData) {
      const trackConversionFacebook = await getClient(config.id);

      if (trackConversionFacebook) {
        const value = eventData ? eventData.data : eventData;

        if (log) {
          log('[Analytics_Facebook_Conversion]', { eventName, value });
        }

        if (!noPublish) {
          trackConversionFacebook.push(['track', 'PageView']);
          trackConversionFacebook.push(value);
        }
      }
    }
  };
}

export default facebook;
